export const QUERY_KEYS = {
  commodities: 'commodities',
  customerCommodities: 'customer-commodities',
  userMappings: 'user-mappings',
  commodityUserMappings: 'commodity-user-mappings',
  commodityList: 'commodity-list',
  users: 'users',
  commoditySummary: 'commodity-summary',
  freight: 'freight',
  customerPrices: 'customer-prices',
} as const;

export const MUTATION_KEYS = {
  updateProduct: 'update-product',
  massUpdateProduct: 'mass-update-product',
  massAcceptProduct: 'mass-accept-product',
  updateUserMapping: 'update-user-mapping',
  createUserMapping: 'create-user-mapping',
  deleteUserMapping: 'delete-user-mapping',
  userActivityEvent: 'user-activity-event',
} as const;
